// extracted by mini-css-extract-plugin
export default {"terms":"ModalTerms_terms__vzRNY","privacy":"ModalTerms_privacy__3vmrx","tabMenu":"ModalTerms_tabMenu__WqfBS","active":"ModalTerms_active__vkEAG","scroll":"ModalTerms_scroll__YFD4f"};